import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import './LabelPhilosophy.css';

const LabelPhilosophy = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      const elements = sectionRef.current.querySelectorAll('.fade-in');
      elements.forEach(el => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="label-philosophy" ref={sectionRef}>
      <div className="container">
        <div className="philosophy-content">
          <div className="philosophy-text">
            <span className="section-label fade-in">The Anyone Story</span>
            <h2 className="fade-in">We didn't start with an office</h2>
            <p className="philosophy-description fade-in">
              Anyone Music Records started in studios, late nights, and conversations about what was missing — 
              not what already existed. This is a new chapter, built by artists, for artists, with the intention 
              to grow something rooted, focused, and built to last.
            </p>
            
            <p className="philosophy-quote fade-in">
              "We're here to push boundaries — not to fit in."
            </p>
            
            <Link to="/about" className="btn btn-secondary fade-in">
              Learn About AMR <ArrowRight size={18} />
            </Link>
          </div>

          <div className="philosophy-visual fade-in">
            <img 
              src="https://images.unsplash.com/photo-1766650585020-4d290ccd19a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxESiUyMG1peGluZyUyMHR1cm50YWJsZXMlMjBjbHViJTIwcGVyZm9ybWFuY2V8ZW58MHx8fHwxNzc0OTkyMjg0fDA&ixlib=rb-4.1.0&q=85" 
              alt="DJ mixing"
              className="philosophy-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LabelPhilosophy;
